import { render, staticRenderFns } from "./page.vue?vue&type=template&id=c3eb87ea&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=c3eb87ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3eb87ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayerBreadcrumbs: require('/usr/src/app/components/player/breadcrumbs.vue').default,PlayerSidebar: require('/usr/src/app/components/player/sidebar.vue').default,PlayerTabsync: require('/usr/src/app/components/player/tabsync.vue').default,PlayerLessonTabs: require('/usr/src/app/components/player/lesson-tabs.vue').default,ModalCartBase: require('/usr/src/app/components/modal/cart/Base.vue').default})
